import { Guid, Nillable } from '@web/utils';
import { AdminBrandDetailsFormSocialMediaCollection } from './admin-brand-details-form-social-media-collection';
import { FormControl, FormGroup } from '@angular/forms';
import { AdminMultimediaImageUpload } from '@web/shared/module/multimedia';
import { AdminBrandStatus } from '@web/shared/module/brand';

export class AdminBrandDetailsForm {
  public constructor(
    private readonly data: {
      name: string;
      description?: Nillable<string>;
      logoId?: Nillable<Guid>;
      illustrationId?: Nillable<Guid>;
      status: AdminBrandStatus;
      homeUrl?: Nillable<string>;
      socialMedia?: Nillable<AdminBrandDetailsFormSocialMediaCollection>;
      slug?: Nillable<string>;
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get description(): Nillable<string> {
    return this.data.description;
  }

  public get logoId(): Nillable<Guid> {
    return this.data.logoId;
  }

  public get illustrationId(): Nillable<Guid> {
    return this.data.illustrationId;
  }

  public get status(): AdminBrandStatus {
    return this.data.status;
  }

  public get homeUrl(): Nillable<string> {
    return this.data.homeUrl;
  }

  public get socialMedia(): Nillable<AdminBrandDetailsFormSocialMediaCollection> {
    return this.data.socialMedia;
  }

  public get slug(): Nillable<string> {
    return this.data.slug;
  }
}

export type AdminBrandDetailsFormGroup = FormGroup<{
  description: FormControl<Nillable<string>>;
  homeUrl: FormControl<Nillable<string>>;
  illustration: FormControl<Nillable<AdminMultimediaImageUpload>>;
  logo: FormControl<Nillable<AdminMultimediaImageUpload>>;
  name: FormControl<string>;
  slug: FormControl<Nillable<string>>;
  socials: FormControl<Nillable<AdminBrandDetailsFormSocialMediaCollection>>;
  status: FormControl<Nillable<AdminBrandStatus>>;
}>;
